
import service from '../../proxy/service'

const items = {}


// 获取app主题
items.getAppTheme = function () {
  var para = {
    __func_name: 'getFinanceTheme'
  }
  return service.native(para)
}

items.callRedirect = (attach) => {
  var data = {
    __func_name: 'callPageSwitch',
    attach: JSON.stringify(attach)
  }
  return service.native(data)
}

items.openUrl = (purl, ptitle = '') => {
  var data = {
    __func_name: 'openUrl',
    url: purl,
    title: ptitle
  }
  return service.native(data)
}

items.closeNativeBtn = (type) => {
  return service.native({
    __func_name: 'setBackBtn',
    type: type
  })
}
// 监听是否是生产环境
items.isProduction = () => {
  // 生产环境url
  if (location.href.indexOf('u.95579.com') > -1) {
    return true
  } else {
    return false
  }
}

items.routerRedirect = (addr, context) => {
  if ((navigator.userAgent.indexOf('cjsccjeh') > -1)) {
    if (addr == -1) {
      var para = {
        __func_name: 'webview_close'
      }
      service.native(para)
      return false
    }
    var data = {
      "category": "link",
      "info": {
        "url": location.origin + location.pathname + '#' + addr,
        "interactive": "1",
        "title": "",
        "isHiddenTopBar":"1"
      }
    }
    items.callRedirect(data)
  } else {
    if (addr == -1) {
      context.$router.go(-1)
      return false
    }
    context.$router.push(addr)
  }
}


export default items
